import {Modal, Input, Button, Select, Form, InputNumber, Radio} from "antd";
import React, {useState} from "react";
import {useFormik} from "formik";
import moment from "moment";
import stores from "../../../store/stores";
import {courierRequestPriorityEnums} from "constants/constants";
import {ZoneSelect} from "components/_defaultComponents/ZoneSelect";
import {ZoneSubcompaniesSelect} from "../components/zoneSubcompaniesSelect/ZoneSubcompaniesSelect";
import {CourierRequestPrioritySelect} from "../components/courierRequestPrioritySelect/CourierRequestPrioritySelect";
import WorkingModelFilter from "components/_defaultComponents/FilterComponents/WorkingModelTypeFilter";

export const CreateCourierRequestModal = ({visibility, onCancel, callbackFunc = () => {}}) => {
    const [loading, setLoading] = useState(false);

    // Pazar günü kontrolü (0 = Pazar)
    const isSunday = moment().day() === 0;

    const formik = useFormik({
        initialValues: {
            zoneId: undefined,
            subCompanyId: undefined,
            requestedCourierCount: 1,
            priority: courierRequestPriorityEnums.NORMAL,
            workingModelId: undefined,
            note: undefined,
            weekNumber: moment().week()
        },

        validate: values => {
            const errors = {};

            if (!values.zoneId) {
                errors.zoneId = "Bölge adı zorunludur!";
            }

            if (!values.subCompanyId) {
                errors.subCompanyId = "Alt firma seçimi zorunludur!";
            }

            if (!values.requestedCourierCount) {
                errors.requestedCourierCount = "Talep edilen kurye sayısı zorunludur!";
            } else if (values.requestedCourierCount <= 0) {
                errors.requestedCourierCount = "Talep edilen kurye sayısı 0'dan büyük olmalıdır!";
            }

            if (!values.priority) {
                errors.priority = "Öncelik seçimi zorunludur!";
            }

            if (!values.workingModelId) {
                errors.workingModelId = "Çalışma modeli seçimi zorunludur!";
            }

            if (!values.weekNumber) {
                errors.weekNumber = "Talep haftası seçimi zorunludur!";
            }

            return errors;
        },
        onSubmit: async values => {
            setLoading(true);
            try {
                const result = await stores.courierRequestStore.createCourierRequest({
                    zoneId: values.zoneId,
                    subCompanyId: values.subCompanyId,
                    requestedCourierCount: values.requestedCourierCount,
                    priority: values.priority,
                    workingModelId: values.workingModelId,
                    note: values.note,
                    weekNumber: values.weekNumber
                });

                if (result) {
                    callbackFunc();
                    formik.resetForm();
                    onCancel();
                }
            } catch (error) {
                console.error("Form submission failed:", error);
            } finally {
                setLoading(false);
            }
        }
    });

    const handleCancel = () => {
        formik.resetForm();
        onCancel();
    };

    if (!visibility) {
        return null;
    }

    return (
        <Modal
            title="Yeni Kurye Talebi Oluştur"
            visible={true}
            onCancel={handleCancel}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    İptal
                </Button>,
                <Button key="submit" type="primary" loading={loading} onClick={formik.handleSubmit}>
                    Oluştur
                </Button>
            ]}
            width={600}
            destroyOnClose={true}
        >
            <form onSubmit={formik.handleSubmit} style={{marginTop: 20}}>
                <div style={{marginBottom: 16}}>
                    <label
                        style={{
                            display: "block",
                            marginBottom: 8,
                            fontSize: "14px",
                            fontWeight: 500
                        }}
                    >
                        Bölge *
                    </label>
                    <ZoneSelect
                        showTitle={false}
                        value={formik.values.zoneId}
                        marginBottom="0px"
                        onChange={value => {
                            formik.setFieldValue("zoneId", value);
                            formik.setFieldValue("subCompanyId", undefined);
                        }}
                        status={formik.touched.zoneId && formik.errors.zoneId ? "error" : ""}
                    />
                    {formik.touched.zoneId && formik.errors.zoneId && (
                        <div style={{color: "#ff4d4f", fontSize: "12px", marginTop: 4}}>
                            {formik.errors.zoneId}
                        </div>
                    )}
                </div>
                <div style={{marginBottom: 16}}>
                    <label
                        style={{
                            display: "block",
                            marginBottom: 8,
                            fontSize: "14px",
                            fontWeight: 500
                        }}
                    >
                        Bölge Alt Firma *
                    </label>
                    <ZoneSubcompaniesSelect
                        showTitle={false}
                        zoneId={formik.values.zoneId}
                        value={formik.values.subCompanyId}
                        onChange={value => formik.setFieldValue("subCompanyId", value)}
                        marginBottom="0px"
                        status={
                            formik.touched.subCompanyId && formik.errors.subCompanyId ? "error" : ""
                        }
                    />
                    {formik.touched.subCompanyId && formik.errors.subCompanyId && (
                        <div style={{color: "#ff4d4f", fontSize: "12px", marginTop: 4}}>
                            {formik.errors.subCompanyId}
                        </div>
                    )}
                </div>
                <div style={{marginBottom: 16}}>
                    <label
                        style={{
                            display: "block",
                            marginBottom: 8,
                            fontSize: "14px",
                            fontWeight: 500
                        }}
                    >
                        Talep Haftası *
                    </label>
                    <Radio.Group
                        value={formik.values.weekNumber}
                        onChange={e => formik.setFieldValue("weekNumber", e.target.value)}
                        style={{width: "100%"}}
                    >
                        <Radio value={moment().week()} disabled={isSunday}>
                            {moment().week()}. Hafta
                        </Radio>
                        <Radio
                            value={moment()
                                .add(1, "week")
                                .week()}
                        >
                            {moment()
                                .add(1, "week")
                                .week()}
                            . Hafta
                        </Radio>
                    </Radio.Group>
                    {formik.touched.weekNumber && formik.errors.weekNumber && (
                        <div style={{color: "#ff4d4f", fontSize: "12px", marginTop: 4}}>
                            {formik.errors.weekNumber}
                        </div>
                    )}
                </div>
                <div style={{marginBottom: 16}}>
                    <label
                        style={{
                            display: "block",
                            marginBottom: 8,
                            fontSize: "14px",
                            fontWeight: 500
                        }}
                    >
                        Talep Edilen Kurye Sayısı *
                    </label>
                    <InputNumber
                        style={{width: "100%"}}
                        value={formik.values.requestedCourierCount}
                        onChange={value => formik.setFieldValue("requestedCourierCount", value)}
                        min={1}
                        precision={0}
                        placeholder="5"
                        type="number"
                        status={
                            formik.touched.requestedCourierCount &&
                            formik.errors.requestedCourierCount
                                ? "error"
                                : ""
                        }
                    />
                    {formik.touched.requestedCourierCount &&
                        formik.errors.requestedCourierCount && (
                            <div style={{color: "#ff4d4f", fontSize: "12px", marginTop: 4}}>
                                {formik.errors.requestedCourierCount}
                            </div>
                        )}
                </div>
                <div style={{marginBottom: 16}}>
                    <label
                        style={{
                            display: "block",
                            marginBottom: 8,
                            fontSize: "14px",
                            fontWeight: 500
                        }}
                    >
                        Öncelik *
                    </label>
                    <CourierRequestPrioritySelect
                        showTitle={false}
                        value={formik.values.priority}
                        onChange={value => formik.setFieldValue("priority", value)}
                        marginBottom="0px"
                        status={formik.touched.priority && formik.errors.priority ? "error" : ""}
                    />
                    {formik.touched.priority && formik.errors.priority && (
                        <div style={{color: "#ff4d4f", fontSize: "12px", marginTop: 4}}>
                            {formik.errors.priority}
                        </div>
                    )}
                </div>
                <div style={{marginBottom: 16}}>
                    <label
                        style={{
                            display: "block",
                            marginBottom: 8,
                            fontSize: "14px",
                            fontWeight: 500
                        }}
                    >
                        Çalışma Modeli *
                    </label>
                    <WorkingModelFilter
                        disabled={false}
                        showLabel={false}
                        showAllOption={false}
                        value={formik.values.workingModelId}
                        onChange={value => formik.setFieldValue("workingModelId", value)}
                        marginBottom="0px"
                        status={
                            formik.touched.workingModelId && formik.errors.workingModelId
                                ? "error"
                                : ""
                        }
                    />
                    {formik.touched.workingModelId && formik.errors.workingModelId && (
                        <div style={{color: "#ff4d4f", fontSize: "12px", marginTop: 4}}>
                            {formik.errors.workingModelId}
                        </div>
                    )}
                </div>
                <div style={{marginBottom: 16}}>
                    <label
                        style={{
                            display: "block",
                            marginBottom: 8,
                            fontSize: "14px",
                            fontWeight: 500
                        }}
                    >
                        Not
                    </label>
                    <Input.TextArea
                        id="note"
                        name="note"
                        value={formik.values.note}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        placeholder="Not"
                    />
                </div>
            </form>
        </Modal>
    );
};
